<template>
  <div>
    <div class="flex flex-wrap mt-4">
      <div class="w-full mb-12 xl:mb-0 px-4">
        <gallery-form />
      </div>
    </div>
  </div>
</template>
<script setup>
// eslint-disable-next-line no-unused-vars
import GalleryForm from "@/components/Form/GalleryForm.vue";
</script>
